import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingService } from '../../service/loading.service';
import { LoaderComponent } from '../loader/loader.component';

@Component({
  standalone: true,
  selector: 'app-loading-overlay',
  imports: [CommonModule, LoaderComponent],
  templateUrl: './loading-overlay.component.html',
  styleUrls: ['./loading-overlay.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoadingOverlayComponent {
  constructor(public loadingService: LoadingService) {}
}
